import React from "react";

import {
  Button,
  FormError,
  FormInput,
  FormLabel,
} from "../../../Components/Basic";
import { customClasses } from "../../../Styles/customClasses";
//form
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Loader } from "../../../Components/Basic/Loader";

// schema
const userContactSchema = yup.object().shape({
  user_email: yup
    .string()
    .email("Check your email")
    .required("This is required")
    .nullable(),
  user_phone: yup.string().required("This is required").nullable(),
  user_name: yup.string().required("This is required").nullable(),
});

function LetUsCallYou({ onSubmit, store }) {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(userContactSchema),
  });
  return (
    <form id="divorce-form" onSubmit={handleSubmit(onSubmit)}>
      <div className={customClasses.stepsWrapper}>
        <div className=" flex flex-col justify-center bg-gray-50 h-5/6 md:h-5/6 rounded shadow-lg px-10 pt-10 pb-10">
          <p className="text-3xl font-bold text-nativeBlue-200">
            Enter Your Details & We'll Call You
          </p>
          <p className={customClasses.questionText}>Your Full Name *</p>
          <FormInput
            placeholder="E.g John Citizen"
            id="user_name"
            type="text"
            name="user_name"
            error={errors?.user_name?.message}
            register={register}
            className="mt-4"
          />
          <FormError error={errors.user_name?.message} />
          <p className={customClasses.questionText}>Your email address *</p>
          <FormInput
            placeholder="example@gmail.com"
            id="user_email"
            type="email"
            name="user_email"
            error={errors?.user_email?.message}
            register={register}
            className="mt-4"
          />
          <FormError error={errors.user_email?.message} />
          <p className={customClasses.questionText}>Your Mobile Number *</p>

          <FormInput
            placeholder="0401 111 222"
            id="user_phone"
            type="text"
            name="user_phone"
            error={errors?.user_email?.message}
            register={register}
            className="mt-4"
          />
          <FormError error={errors.user_phone?.message} />
        </div>
      </div>
    </form>
  );
}

export default LetUsCallYou;
